import CaretLink from './CaretLink'

export default CaretLink
